import React from 'react'
import cx from 'classnames'
import Icon from 'components/Icon'
import style from './styles.m.sass'
import CenteredContent from 'components/CenteredContent'
import Button from '../Button'

interface ContentErrorProps {
  title?: string
  error: any
  large?: boolean

  onRetryClick?(): unknown
}

export default function ContentError({
  title,
  error,
  onRetryClick,
  large,
}: ContentErrorProps) {
  return (
    <CenteredContent>
      <div className={cx(style.contentError, large && style.large)}>
        <Icon name="info" className={style.bigIcon} />
        <h3 className={cx(style.title, style.contentError)}>
          {title || 'An error occured'}
        </h3>
        {error && (
          <div className={cx(style.contentError, style.error)}>
            {typeof error === 'string'
              ? error
              : error.response && error.response.data
              ? error.response.data.message
              : error.message}
          </div>
        )}
        {onRetryClick && (
          <div className={cx(style.contentError, style.retryContainer)}>
            <Button flat type="danger" onClick={onRetryClick}>
              Retry
            </Button>
          </div>
        )}
      </div>
    </CenteredContent>
  )
}
